// @flow
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components';

const Container = styled.div`
  cursor: pointer;
  user-select: none;
  outline: none;
`;

const Text = styled.span`
  ${props =>
    props.textAlign === 'right' &&
    css`
      margin-left: 0.5rem;
    `}

  ${props =>
    props.textAlign === 'left' &&
    css`
      margin-right: 0.5rem;
    `}
`;

const TickBox = (props: {
  text: string,
  value: boolean,
  textAlign: 'left' | 'right',
  className?: string,
  onChange: (value: boolean) => void
}) => {
  const renderText = () =>
    props.text === '' ? null : (
      <Text textAlign={props.textAlign}>{props.text}</Text>
    );

  const renderTextLeft = () =>
    props.textAlign === 'left' ? renderText() : null;

  const renderTextRight = () =>
    props.textAlign === 'right' ? renderText() : null;

  return (
    <Container
      className={props.className}
      role="checkbox"
      aria-checked={props.value}
      tabIndex="0"
      onClick={props.onChange.bind(this, !props.value)}
    >
      {renderTextLeft()}
      <FontAwesomeIcon
        icon={['far', props.value ? 'check-square' : 'square']}
        size="lg"
        aria-hidden="true"
      />
      {renderTextRight()}
    </Container>
  );
};

TickBox.defaultProps = {
  text: '',
  textAlign: 'left',
  onChange: () => {}
};

export default TickBox;
